export default __webpack_public_path__ + "static/media/5_banner-ux-ui.83776739.jpg";